<template>
  <div class="pbv-angles">
    <div
      v-for="(item, index) in value"
      :key="index"
      class="pbv-angles__row"
      :class="{ 'pbv-angles__row--off': !item.selected }"
    >
      <v-checkbox
        :input-value="item.selected"
        hide-details
        dense
        class="pbv-angles__check mt-0 pt-0"
        @change="update(index, 'selected', $event)"
      />

      <rmr-text-field
        :value="item.angle"
        placeholder="Angle de l'article"
        size="sm"
        class="pbv-angles__field"
        @input="update(index, 'angle', $event)"
      />

      <!--
        Le time code est INFORMATIF et non editable : les bornes viennent du
        decoupage propose par le LLM et sont appliquees cote serveur. Laisser
        les retoucher ici ouvrirait la porte a des bornes incoherentes sans
        que l'editeur puisse verifier ce qu'elles contiennent.
      -->
      <rmr-status-chip
        v-if="hasRange(item)"
        :label="`${timecode(item.start_s)} – ${timecode(item.end_s)}`"
        variant="primary"
        size="md"
        fixed
      />
      <rmr-status-chip
        v-else
        label="vidéo entière"
        variant="neutral"
        size="md"
        fixed
      />

      <rmr-icon-button
        :icon="icons.mdiClose"
        variant="delete"
        size="xs"
        tooltip="Retirer cet angle"
        @click="$emit('remove', index)"
      />
    </div>

    <rmr-action-button
      label="Ajouter un angle"
      :icon="icons.mdiPlus"
      variant="ghost"
      size="sm"
      class="mt-2"
      @click="$emit('add')"
    />
  </div>
</template>

<script>
import { set } from "@vue/composition-api";
import { mdiClose, mdiPlus } from "@mdi/js";

import RmrActionButton from "@/components/ui/actions/RmrActionButton.vue";
import RmrIconButton from "@/components/ui/actions/RmrIconButton.vue";
import RmrStatusChip from "@/components/ui/feedback/RmrStatusChip.vue";
import RmrTextField from "@/components/ui/forms/RmrTextField.vue";

export default {
  name: "VideoAngleList",
  components: {
    RmrActionButton,
    RmrIconButton,
    RmrStatusChip,
    RmrTextField,
  },
  props: {
    /** `[{ angle, start_s, end_s, selected }]` */
    value: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    // =>  METHODS
    /**
     * On mute l'objet en place plutot que de reemettre tout le tableau : les
     * elements sont crees d'un bloc par `proposeAngles`, donc deja reactifs en
     * Vue 2. `set` plutot que l'affectation directe : le piege des cles ajoutees
     * apres coup ne concerne pas ces cles, mais `set` reste sur.
     */
    const update = (index, key, val) => {
      set(props.value[index], key, val);
    };

    const hasRange = (item) => item.start_s !== null && item.end_s !== null;

    const timecode = (seconds) => {
      const total = Math.max(0, Math.round(Number(seconds) || 0));
      const minutes = Math.floor(total / 60);
      return `${String(minutes).padStart(2, "0")}:${String(total % 60).padStart(
        2,
        "0"
      )}`;
    };

    // =>  DATA
    return { hasRange, icons: { mdiClose, mdiPlus }, timecode, update };
  },
};
</script>

<style lang="scss" scoped>
.pbv-angles__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: $rmr-radius-md;
  transition: background 0.15s ease;

  &:hover {
    background: $rmr-surface-1;
  }
}

.pbv-angles__row--off {
  opacity: 0.55;
}

.pbv-angles__check {
  flex: 0 0 auto;
}

.pbv-angles__field {
  flex: 1 1 auto;
  min-width: 0;
}
</style>
